import React from 'react';
import { replace } from 'react-router-redux';

import {ROUTE_HOME, ROUTE_SIGNIN,  ROUTE_DASHBOARD} from '../../../constants/routeconstants';
import { connect } from 'react-redux';
import UserRoles from "../../../../../common/src/enums/UserRoles";

class Home extends React.Component {

    static getId() {
        return ROUTE_HOME;
    }

    static getAllowedRoles() {
        return [UserRoles.USER, UserRoles.CLUB_ADMIN, UserRoles.SECTION_ADMIN, UserRoles.MAIN_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (this.props.auth.isAuthenticated && (this.props.auth.isClubAdmin || this.props.auth.isSectionAdmin || this.props.auth.isMainAdmin)) this.props.dispatch(replace(ROUTE_DASHBOARD));
        else this.props.dispatch(replace(ROUTE_SIGNIN));
    }

    render() {
        return (
            <div>
                <div className="sub-page-title"/>
                <div className="sub-page-content">
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: {
        isAuthenticated: state.auth.isAuthenticated,
        isMainAdmin: state.auth.isMainAdmin,
        isClubAdmin: state.auth.isClubAdmin,
        clubNumber: state.auth.clubNumber,
    }
});

export default connect(mapStateToProps)(Home);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/home/Home.js